import { ApolloLink } from '@apollo/client/core/index.js'

export const headerLink = new ApolloLink((operation, forward) => {
  return forward(operation).map(result => {
    const context = operation.getContext()
    if (context.response && context.onResponseHeaders) {
      const {
        response: { headers },
        onResponseHeaders,
      } = context
      onResponseHeaders(headers)
    }
    return result
  })
})
